import styles from './index.module.less'
export default {
    props: {
        item: {
            type:Object
        },
        itemKey: {
            type: String
        }
    },
    methods: {
        disTd() {
            const item = this.item || {}
            const list = item[this.itemKey]
            if (!list) {
                return <div>-</div>
            }
            
            return <div class={styles['download-td']}>
                                { list.map(item => <div class={styles['td-contain']}>
                                                      <p style="margin-bottom: 0px">
                                                          在办公室：<span class={styles['val']}>{item.is_at_office ? '是' : '否'}；</span>
                                                      </p>
                                                      <p style="margin-bottom: 0px">
                                                          工作时长：<span class={styles['val']}>{item.wage_percent}天；</span>
                                                      </p>
                                                      <p style="margin-bottom: 0px">
                                                          奖金：<span class={styles['val']}>{item.bonus}；</span>
                                                      </p>
                                                      <p style="margin-bottom: 0px">
                                                          备注：<span class={styles['val']}>{item.tip}；</span>
                                                      </p>
                                                </div>)}
          </div>
        }
    },
    render() {
    
        const itemKey = this.itemKey
        const item = this.item
        if (itemKey === 'name') {
            return <div class={styles['download-td']}>{item.name}</div>
        }
     
        return this.disTd()
        
    }
}